<script lang="ts">
  interface Props {
    csrfToken: string;
    inviteToken: string;
    inviteAccountName?: string;
    inviteByName?: string;
  }

  let { csrfToken = "", inviteToken = "", inviteAccountName = "", inviteByName = "" }: Props = $props();

  const invitationUrl = $derived(`/account_invitations/${encodeURIComponent(inviteToken)}`);
</script>

<div class="space-y-6">
  <div class="text-center">
    <h1 class="text-4xl font-bold text-foreground">Team invitation</h1>
    <p class="mt-2 text-base text-muted-foreground">
      {#if inviteByName && inviteAccountName}
        <strong>{inviteByName}</strong> invited you to join <strong>{inviteAccountName}</strong>.
      {:else if inviteAccountName}
        You were invited to join <strong>{inviteAccountName}</strong>.
      {:else}
        You have been invited to join a team on DataTurk.ai.
      {/if}
    </p>
  </div>

  <div class="rounded-xl border border-border bg-card p-6 shadow-sm">
    <p class="text-base text-muted-foreground">
      By accepting, your user will be linked to this existing team account. You will not create a new company account or plan.
    </p>

    <div class="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
      <form method="post" action={invitationUrl}>
        <input type="hidden" name="_method" value="put" />
        <input type="hidden" name="authenticity_token" value={csrfToken} />
        <button
          type="submit"
          class="w-full rounded-md bg-primary px-4 py-3 text-base font-medium text-primary-foreground transition-colors hover:bg-primary/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
        >
          Accept invitation
        </button>
      </form>

      <form method="post" action={invitationUrl}>
        <input type="hidden" name="_method" value="delete" />
        <input type="hidden" name="authenticity_token" value={csrfToken} />
        <button
          type="submit"
          class="w-full rounded-md border border-border bg-background px-4 py-3 text-base font-medium text-foreground transition-colors hover:bg-muted focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
        >
          Decline invitation
        </button>
      </form>
    </div>
  </div>
</div>
